const ThrowError: React.FC = () => {
  throw new Error("Testing out Errors");
};

export default ThrowError;
